export default __webpack_public_path__ + "static/media/idea.493d9379.svg";